import { Select, Slider } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { LangContext } from '../../contexts/langContext';
import { StateContext } from '../../contexts/stateContext';
import { defaultDob, _getNewDesignRange } from '../utilsDesign';
import { Icon } from './Icon';
import TimeTicks from './TimeTicks';

const { Option } = Select;

const MAX_HOURS = 11;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    font-weight: bold !important;
  }

  .ant-select-selection-item {
    font-weight: bold !important;
  }

  .ant-select-item-option-content {
    font-weight: bold !important;
  }
`;

export function TimeRange(props) {

  const {
    hideHandler,
    avatar = {},
    applyNewDate = () => void (0),
    style = {},
    top,
  } = props;
  const context = { ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const [localValue, setLocalValue] = useState(50);
  const [dob, setDob] = useState(avatar.dob ? avatar.dob : defaultDob);
  const [hoursPlus, setHoursPlus] = useState(1);
  // Topbar always mounts this control. Do not hit /api/dates or write
  // tryDesignDate until the user actually moves the slider / ±hours.
  const [interacted, setInteracted] = useState(!top);

  useEffect(() => {
    if (avatar.dob && avatar.dob !== dob) setDob(avatar.dob)
    if (!avatar.dob) setDob('1990-01-01T12:00')
    setLocalValue(50)
    if (top) setInteracted(false)
  }, [avatar])

  useEffect(() => {
    if (!interacted) return;
    const ranges = getRanges(avatar);
    const selectedTime = new Date(ranges.originalDate);
    const totalMinutes = hoursPlus * 120; // Total minutes for the range
    const minutesOffset = ((localValue - 50) / 50) * (hoursPlus * 60);
    selectedTime.setMinutes(selectedTime.getMinutes() + minutesOffset);

    const formattedSelectedTime =
      selectedTime.getFullYear() +
      '-' +
      ('0' + (selectedTime.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + selectedTime.getDate()).slice(-2) +
      'T' +
      ('0' + selectedTime.getHours()).slice(-2) +
      ':' +
      ('0' + selectedTime.getMinutes()).slice(-2) +
      ':' +
      ('0' + selectedTime.getSeconds()).slice(-2);

    context.setState.setTryDesignDate(formattedSelectedTime);
  }, [localValue, hoursPlus, interacted]);

  const saveNewDesign = () => {
    const ranges = getRanges(avatar);
    const totalMinutes = hoursPlus * 120; // Total minutes for the range
    const minutesOffset = ((localValue - 50) / 50) * (hoursPlus * 60);
    const selectedTime = new Date(ranges.originalDate);
    selectedTime.setMinutes(selectedTime.getMinutes() + minutesOffset);

    const formattedSelectedTime =
      selectedTime.getFullYear() +
      '-' +
      ('0' + (selectedTime.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + selectedTime.getDate()).slice(-2) +
      'T' +
      ('0' + selectedTime.getHours()).slice(-2) +
      ':' +
      ('0' + selectedTime.getMinutes()).slice(-2) +
      ':' +
      ('0' + selectedTime.getSeconds()).slice(-2);

    applyNewDate(formattedSelectedTime);
    setDob(formattedSelectedTime);
    setLocalValue(50);
    hideHandler();
  };


  const applyNewDesign = (ranges, newValue) => {
    const selectedTime = new Date(ranges.originalDate);
    const totalMinutes = hoursPlus * 120; // Total minutes for the range
    const minutesOffset = ((newValue - 50) / 50) * (hoursPlus * 60);
    selectedTime.setMinutes(selectedTime.getMinutes() + minutesOffset);

    const formattedSelectedTime =
      selectedTime.getFullYear() +
      '-' +
      ('0' + (selectedTime.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + selectedTime.getDate()).slice(-2) +
      'T' +
      ('0' + selectedTime.getHours()).slice(-2) +
      ':' +
      ('0' + selectedTime.getMinutes()).slice(-2) +
      ':' +
      ('0' + selectedTime.getSeconds()).slice(-2);

    context.setState.setTryDesignDate(formattedSelectedTime);
  };

  const getRanges = (avatar) => {
    const parsed = new Date(avatar.dob || defaultDob);
    const originalDate = Number.isNaN(parsed.getTime()) ? new Date(defaultDob) : parsed;
    const minDate = new Date(originalDate);
    minDate.setHours(originalDate.getHours() - hoursPlus);
    minDate.setSeconds(0);

    const maxDate = new Date(originalDate);
    maxDate.setHours(originalDate.getHours() + hoursPlus);
    maxDate.setSeconds(0);

    return {
      min: minDate.toISOString(),
      time: originalDate.toISOString(),
      max: maxDate.toISOString(),
      originalDate,
    };
  };

  const getMarks = (value, ranges) => {
    const formatTime = (date) => {
      const pad = (num) => String(num).padStart(2, '0');
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      return `${hours}:${minutes}`;
    };

    const minTime = new Date(ranges.min);
    const maxTime = new Date(ranges.max);
    const originalTime = new Date(ranges.originalDate);

    const marks = {
      0: formatTime(minTime),
      50: formatTime(originalTime),
      100: formatTime(maxTime),
    };

    if (value !== 50) {
      const minutesOffset = ((value - 50) / 50) * (hoursPlus * 60);
      const selectedTime = new Date(originalTime);
      selectedTime.setMinutes(selectedTime.getMinutes() + minutesOffset);

      marks[value] = {
        style: {
          background: 'white',
          color: '#000000',
          height: '1.6em',
          padding: '0.8em 0 0 0',
          position: 'relative',
          zIndex: 1,
        },
        label: <strong>{formatTime(selectedTime)}</strong>,
      };
    }

    return marks;
  };

  const onChange = (newValue) => {
    setInteracted(true);
    setLocalValue(newValue);
  };

  const setVal = (newValue) => {
    setLocalValue(newValue);
    const ranges = getRanges(avatar);
    applyNewDesign(ranges, newValue); // Pass the newValue directly to applyNewDesign
  }

  const onChangeComplete = (newValue) => {
    // const ranges = getRanges();
    // applyNewDesign(ranges, newValue);
  };

  const tooltipFormatter = (value) => {
    const ranges = getRanges(avatar);
    const totalMinutes = hoursPlus * 120; // Total minutes for the range
    const minutesOffset = ((value - 50) / 50) * (hoursPlus * 60);
    const selectedTime = new Date(ranges.originalDate);
    selectedTime.setMinutes(selectedTime.getMinutes() + minutesOffset);

    const pad = (num) => String(num).padStart(2, '0');
    const hours = pad(selectedTime.getHours());
    const minutes = pad(selectedTime.getMinutes());
    return `${hours}:${minutes}`;
  };

  const ranges = getRanges(avatar);
  const [marks, setMarks] = useState(getMarks(localValue, ranges));
  const [rangeDesign, setRangeDesign] = useState([]);


  useEffect(() => {
    const ranges = getRanges(avatar);
    setMarks(getMarks(localValue, ranges))
    if (!interacted || !avatar.token) return;

    _getNewDesignRange(ranges.min, ranges.max, (d) => {
      const avatarRange = {}
      avatarRange[avatar.token] = d;
      context.setState.setRectificationDesigns(prev => ({ ...prev, ...avatarRange }))
    })
  }, [hoursPlus, avatar.token, interacted])

  useEffect(() => {
    const ranges = getRanges(avatar);
    setMarks(getMarks(localValue, ranges));
  }, [localValue, dob]);

  const handleHoursChange = (value) => {
    setInteracted(true);
    setHoursPlus(value);
  };

  const hourOptions = Array.from({ length: MAX_HOURS }, (_, i) => i + 1);

  return (<>
    <div className="x_time_uncertain_range0" style={{ ...style }}>



      <div className="x_time_uncertain_hoursplus">
        <StyledSelect
          defaultValue={1}
          size='small'
          style={{ width: 86 }}
          onChange={handleHoursChange}
          value={hoursPlus}
        >
          {hourOptions.map(hours => (
            <Option key={hours} value={hours}>
              ±{hours} {$ui('time_hrs')}
            </Option>
          ))}
        </StyledSelect>
      </div>

      {/* <div className={`mobile_v_yes x_button x_button--sm  x_button--ghost`}
        onClick={() => {
          setVal(50)
          hideHandler()
        }}
      >
        <Icon size={40}>close</Icon>
      </div> */}

      <div className="x_time_uncertain_range_scale mobile_v_no">

        <TimeTicks hoursPlus={hoursPlus} dob={dob} />

        <StyledSlider
          onMouseEnter={(e) => e.stopPropagation()}
          // min={0}
          // max={100}
          dotSize={16}
          marks={marks}
          value={localValue}
          onChange={onChange}
          onChangeComplete={onChangeComplete} // Changed from onChangeComplete to onAfterChange
          // tooltip={{ formatter: tooltipFormatter }}
          tooltip={{ formatter: null }}
          dotActiveBorderColorActive='002bff'
        />
      </div>
      {/* <div className="mobile_v_yes x_time_uncertain_range_scale ">
        <StyledSlider
          // min={0}
          // max={100}
          dotSize={16}
          style={{ width: '100%' }}
          // marks={marks}
          value={localValue}
          onChange={onChange}
          onChangeComplete={onChangeComplete} // Changed from onChangeComplete to onAfterChange
          tooltip={{
            formatter: tooltipFormatter
          }}
          // tooltip={{ formatter: null }}
          dotActiveBorderColorActive='002bff'
        />
      </div> */}

      <div className="x_time_uncertain_right">
        <div className={`x_button x_button--sm x_button--ghost ${localValue === 50 ? 'inactive' : ''}`} onClick={() => setVal(50)}>
          {$ui('time_reset')}
        </div>
      </div>

      {!top && avatar.my && <>
        <div className={`x_button x_button--sm  ${localValue === 50 ? 'x_button--ghost inactive' : ''}`} onClick={() => saveNewDesign()}>
          {$ui('time_save')}
        </div>

        <div className={`x_button x_button--sm  ${localValue === 50 ? 'x_button--ghost inactive' : ''}`} onClick={() => saveNewDesign()}>
          <Icon size={40}>check</Icon>
        </div>
      </>}
    </div>

  </>
  );
}



const StyledSlider = styled(Slider)`
  .ant-slider-track-active {
    background-color: ${({ controlSize }) => controlSize || '#002bff'}; /* Default green */
  }

  .ant-slider-handle {
    border-color: ${({ controlSize }) => controlSize || '#002bff'}; /* Default blue */
    background-color: #fff;
    z-index:2;
    transform: translateX(-50%) scale(1.6) !important;
  }
  .ant-slider-handle-active {
    border-color: ${({ controlSize }) => controlSize || '#002bff'}; /* Default blue */
    background-color: #fff;
    z-index:2;
  }
  .ant-slider-handle-active::after {
    box-shadow: 0 0 0 2px #002bff;
  }

  .ant-slider-dot-active {
    border-color: ${({ dotActiveBorderColor }) => dotActiveBorderColor || '#002bff'};
  }
  @media screen and (max-width: 479px) {
    .ant-slider-handle {
      transform: scale(2) !important;
    }
  }

`;
